// extracted by mini-css-extract-plugin
module.exports = {"searchPanel":"Search_searchPanel__RL1_Y"};